export const TEAM_USER_ROLES = {
    owner: 'Owner',
    admin: 'Administrator',
    manager: 'Manager',
    service: 'Service',
    mh_supervisor: 'Supervisor',
    mh_service_rep: 'Service Representative',
    billing: 'Accounting',
    member: 'Member',
    none: 'None',
};

export const GROUP_USER_ROLES = Object.freeze({
    agent: 'Agent',
    blast: 'Blast',
    marketer: 'Marketer',
    admin: 'Administrator',
});

export const ORG_UNIT_USER_ROLES = GROUP_USER_ROLES;

export const DEFAULT_GROUP_ROLE = 'agent';
export const DEFAULT_ORG_UNIT_ROLE = DEFAULT_GROUP_ROLE;

export const teamRolesOptions = ({ exclude = [] }) =>
    Object.keys(TEAM_USER_ROLES)
        .reduce(
            (acc, key) => [
                ...acc,
                {
                    label: TEAM_USER_ROLES[key],
                    value: key,
                },
            ],
            []
        )
        .filter((role) => !exclude.includes(role.value));

export const groupRolesOptions = ({ exclude = [] } = {}) =>
    Object.keys(GROUP_USER_ROLES)
        .reduce(
            (acc, key) => [
                ...acc,
                {
                    label: GROUP_USER_ROLES[key],
                    value: key,
                },
            ],
            []
        )
        .filter((role) => !exclude.includes(role.value));

export const orgUnitRolesOptions = ({ exclude = [] } = {}) =>
    Object.keys(ORG_UNIT_USER_ROLES)
        .reduce(
            (acc, key) => [
                ...acc,
                {
                    label: ORG_UNIT_USER_ROLES[key],
                    value: key,
                },
            ],
            []
        )
        .filter((role) => !exclude.includes(role.value));
